<template>
  <div :class="pageClass">
    <!-- 页面顶部 -->
    <topmenu ref="topmenu" v-if="!isLayout"></topmenu>
    <!-- 页头配置 -->
    <!-- <headerbar ref="headerbar" v-if="isLayout"></headerbar> -->
    <div class="h-topbar-wrapper">
      <topbar ref="topbar"></topbar>
    </div>
    <div class="main-wrapper" :class="{ hideSidebar: !sidebar.opened }">
      <!-- 侧边栏 -->
      <sidebar class="h-sidebar-wrapper"></sidebar>
      <!-- 中间区域 -->
      <!-- 客户端 -->
      <div v-if="!isLayout" class="main-container" :style="{ height: responsive + 'px' }">
        <!-- 面包屑导航栏 -->
        <navbar></navbar>
        <!-- 内容 -->
        <app-main ref="appMain"></app-main>
        <!--公告-->
        <noticebar v-if="isShowNoticeBar"></noticebar>
      </div>
      <!-- 浏览器 -->
      <div v-if="isLayout" class="main-container">
        <!-- 面包屑导航栏 -->
        <navbar></navbar>
        <!-- 内容 -->
        <app-main ref="appMain"></app-main>
        <!--公告-->
        <noticebar v-if="isShowNoticeBar"></noticebar>
      </div>
    </div>
    <div style="margin-top: -20px" v-if="!isLayout">
      <bottombar ref="bottombar"></bottombar>
    </div>
    <footerbar ref="footerbar" v-if="isLayout"></footerbar>
    <wss ref="wss" v-if="isLayout"></wss>
  </div>
</template>
<script>
import {
  Wss,
  Navbar,
  Sidebar,
  AppMain,
  Topbar,
  Noticebar,
  Bottombar,
  Footerbar,
  Topmenu,
} from './index'
import { mapGetters } from 'vuex'
import { on, off } from '@common/utils/commonUtil'
export default {
  name: 'layout',
  components: {
    Wss,
    Navbar,
    Sidebar,
    AppMain,
    Topbar,
    Noticebar,
    Bottombar,
    Footerbar,
    Topmenu,
  },
  computed: {
    sidebar () {
      return this.$store.state.app.sidebar
    },
    pageClass () {
      let classStr = 'app-wrapper'
      if (this.isLayout) {
        classStr = ' app-wrapper-web-page'
      }
      return classStr
    },
    ...mapGetters(['activeIndex']),
  },
  data () {
    return {
      isShowNoticeBar: false,
      responsive: 0,
      isLayout: false,
    }
  },
  methods: {
    handleResize () {
      this.$nextTick(() => {
        let appObj = this.$refs.appMain.$el
        let appOffsetTop = appObj.offsetTop
        let noticeObj = document.getElementsByClassName('h-notice-bar')
        let noticeClientHeight =
          noticeObj.length === 0 ? 0 : noticeObj[0].clientHeight
        this.responsive = window.innerHeight - appOffsetTop - noticeClientHeight
      })
    },
  },
  mounted () {
    this.handleResize()
    on(window, 'resize', this.handleResize)
    let top = 30
    this.$hMessage.config({
      top: top,
      infoTop: top,
      successTop: top,
      warningTop: top,
      errorTop: top,
    })
  },
  activated () {
    this.handleResize()
    on(window, 'resize', this.handleResize)
  },
  deactivated () {
    off(window, 'resize', this.handleResize)
  },
  beforeDestroy () {
    off(window, 'resize', this.handleResize)
  },
  created () {
    let noticeBar = window.LOCAL_CONFIG.isShowNoticeBar + ''
    if (noticeBar === 'true') {
      this.isShowNoticeBar = true
    }
    if (this.$myIpcSend.isWebType()) {
      this.isLayout = true
    }
  },
}
</script>
<style scoped lang="less">
.app-wrapper {
  overflow: hidden;
  /deep/ .h-topbar-wrapper {
    height: 80px;
    z-index: 10;
  }
  /deep/ .h-topbar {
    margin-top: 30px !important;
  }
  .main-wrapper {
    /deep/.h-sidebar-contain {
      top: 75px;
      z-index: 0;
    }
    /deep/ .app-main {
      top: 0;
      margin-top: 80px;
      height: 100%;
      background: #fff;
    }
  }
}
.app-wrapper-web-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  /deep/.h-topbar-wrapper {
    // height: 100px !important;
    position: static !important;
  }
  .h-topbar-wrapper-header {
    width: 100%;
    height: 50px;
    background-color: #ffffff;
  }
  /deep/.main-wrapper {
    // margin-top: 100px;
    flex: 1;
    height: calc(100vh - 140px);
    position: inherit;
    margin: 0 !important;
    display: flex;
    .h-sidebar-contain {
      position: inherit !important;
      top: 0;
      width: 200px;
    }
    .main-container {
      width: calc(100% - 200px);
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .app-main {
      position: inherit !important;
      top: 0;
      background: #fff;
    }
    .h-sidebar-menu {
      position: inherit !important;
    }
    .index-content {
      min-height: 84vh;
      height: 100%;
    }
  }
  .lightblue {
    /deep/ .h-sidebar-contain {
      top: 100px;
    }
  }
  .h-bottombar {
    display: none;
  }
}
.aaa {
  bottom: -1px;
  width: 100%;
  height: 20px;
  position: fixed;
  /* top: 0; */
  z-index: 990;
  border: none;
  border-radius: 0;
  -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
  background: #037df3;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
